import React from "react";
import ImageModalTemplate from "./ImageModalTemplate";

const RadarImageModal = ({ onClose, link }) => {
	return (
		<ImageModalTemplate onClose={onClose} downloadName={"radar"}>
			<h3 className="text-2xl font-bold text-center text-blue-600 mb-0">
				Immagini Radar Regionale
			</h3>
			<img className="w-full object-contain aspect-square p-0" src={link} alt="Radar" />
		</ImageModalTemplate>
	);
};

export default RadarImageModal;
